<template>
    <div class="flex w-full py-4">
        <div class="flex m-auto">
            <div class="wrapper-state">
                <div class="flex flex-1">
                    <div class="state m-auto text-white bg-a-brown-502314 border border-a-brown-502314 flex">
                        <div class="text-14 m-auto">1</div>
                    </div>
                </div>
                <div class="text-a-brown-502314 text-center text-12 pt-1 lg:text-14">{{ lbl.subscription.subscription_summary.choose_package }}</div>
            </div>
            <div class="line-custom border-b border-a-brown-502314 border-dashed"></div>
            <div class="wrapper-state">
                <div class="flex flex-1">
                    <div class="state m-auto border flex bg-a-brown-502314 text-white border-a-brown-502314">
                        <div class="text-14 m-auto">2</div>
                    </div>
                </div>
                <div class="text-center text-12 pt-1 lg:text-14 text-a-brown-502314">Payment</div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: "CartStatus",
    mixins: [LocaleMixin],
}
</script>

<style lang="scss" scoped>
    .wrapper-state {
        width: 80px;
        .state {
            width: 24px;
            height: 24px;
            text-align: center;
            border-radius: 100%;
        }
    }
    .line-custom {
        width: 100px;
        height: 13px;
        margin: 0 -22px;
    }
</style>